export default __webpack_public_path__ + "static/media/information--park-and-ride--g2.c953d0be.png";